export default "__VITE_ASSET__9d3e147e__"